import React, { createContext, useState, useContext } from 'react';

const FormOfferContext = createContext(null);

export const FormOfferProvider = ({ children }) => {
  const [formsData, setFormsData] = useState([]);

  const addFormData = (data) => {
    setFormsData((prev) => [...prev, data]);
  };

  const updateFormData = (index, data) => {
    setFormsData((prev) => {
      const updated = [...prev];
      updated[index] = data;
      return updated;
    });
  };

  return (
    <FormOfferContext.Provider value={{ formsData, addFormData, updateFormData }}>
      {children}
    </FormOfferContext.Provider>
  );
};

export const useFormOfferContext = () => useContext(FormOfferContext);